/* @flow */

import * as types from './signupActionTypes';
import { parseAuthResponse } from 'src/shared/app/authentication/action/base/authenticationActions';
import {
  isDevModeEnabled,
  isErrorReportingEnabled,
} from 'src/shared/app/base/selector/appEnvSelectors';
import {
  signupActivationEndpoint,
  signupEmailEndpoint,
  signupCreateUserEndpoint,
} from 'src/shared/app/base/settings/endpointSettings';
import { parseResponse } from 'src/shared/app/base/util/ajaxUtils';

export function showSignupEmailForm() {
  return {
    type: types.SHOW_SIGNUP_EMAIL_FORM,
  };
}

export function showSignupPasswordForm() {
  return {
    type: types.SHOW_SIGNUP_PASSWORD_FORM,
  };
}

export function showSignupAboutForm() {
  return {
    type: types.SHOW_SIGNUP_ABOUT_FORM,
  };
}

export function showSignupAvatarForm() {
  return {
    type: types.SHOW_SIGNUP_AVATAR_FORM,
  };
}

/*
|------------------------------------------------------------------------------
| VALIDATE ACTIVATION CODE
|------------------------------------------------------------------------------
*/

export function validateSignupActivationCode(
  code: string,
  eventId: number,
): any {
  return (dispatch: any, { post }: Object) => {
    dispatch(validateSignupActivationCodeRequest());

    return post(signupActivationEndpoint(), {
      code,
      event: eventId,
    })
      .then(parseResponse)
      .then(() => dispatch(validateSignupActivationCodeSuccess(code)))
      .catch((exception) => {
        dispatch(validateSignupActivationCodeFailure(exception));

        throw exception;
      });
  };
}

export function validateSignupActivationCodeRequest(): Object {
  return {
    type: types.VALIDATE_SIGNUP_ACTIVATION_CODE_REQUEST,
  };
}

export function validateSignupActivationCodeSuccess(code: string): Object {
  return {
    type: types.VALIDATE_SIGNUP_ACTIVATION_CODE_SUCCESS,
    code,
  };
}

export function validateSignupActivationCodeFailure(exception: Error): Object {
  return {
    type: types.VALIDATE_SIGNUP_ACTIVATION_CODE_FAILURE,
    exception,
  };
}

/*
|------------------------------------------------------------------------------
| VALIDATE EMAIL
|------------------------------------------------------------------------------
*/

export function validateSignupEmail(
  email: string,
  code: string,
  eventId: number,
): any {
  return (dispatch: any, { post }: Object) => {
    dispatch(validateSignupEmailRequest());

    return post(signupEmailEndpoint(), {
      username: email,
      code,
      event: eventId,
    })
      .then(parseResponse)
      .then(({ password_set: isPasswordSet }) =>
        dispatch(validateSignupEmailSuccess(email, isPasswordSet)),
      )
      .catch((exception) => {
        dispatch(validateSignupEmailFailure(exception));

        throw exception;
      });
  };
}

export function validateSignupEmailRequest(): Object {
  return {
    type: types.VALIDATE_SIGNUP_EMAIL_REQUEST,
  };
}

export function validateSignupEmailSuccess(
  email: string,
  isPasswordSet: boolean,
): Object {
  return {
    type: types.VALIDATE_SIGNUP_EMAIL_SUCCESS,
    email,
    isPasswordSet,
  };
}

export function validateSignupEmailFailure(exception: Error): Object {
  return {
    type: types.VALIDATE_SIGNUP_EMAIL_FAILURE,
    exception,
  };
}

/*
|------------------------------------------------------------------------------
| CREATE USER
|------------------------------------------------------------------------------
*/

export function signupCreateUser(
  email: string,
  password: string,
  code: string,
  eventId: number,
): any {
  return (dispatch: any, { post }: Object, getState) => {
    dispatch(signupCreateUserRequest());

    return post(signupCreateUserEndpoint(), {
      username: email,
      code,
      password,
      event: eventId,
    })
      .then(parseResponse)
      .then((json) => {
        const { userId, membershipId, membership, token } = parseAuthResponse(
          dispatch,
          json,
          !isDevModeEnabled(getState()),
          isErrorReportingEnabled(getState()),
        );

        dispatch(signupCreateUserSuccess(userId, membershipId, token));

        return { membership };
      })
      .catch((exception) => {
        dispatch(signupCreateUserFailure(exception));

        throw exception;
      });
  };
}

export function signupCreateUserRequest(): Object {
  return {
    type: types.SIGNUP_CREATE_USER_REQUEST,
  };
}

export function signupCreateUserSuccess(
  userId: number,
  membershipId: number,
  token: string,
): Object {
  return {
    type: types.SIGNUP_CREATE_USER_SUCCESS,
    userId,
    membershipId,
    token,
  };
}

export function signupCreateUserFailure(exception: Error): Object {
  return {
    type: types.SIGNUP_CREATE_USER_FAILURE,
    exception,
  };
}

/*
|------------------------------------------------------------------------------
| COMPLETION
|------------------------------------------------------------------------------
*/

export function markSignupAsComplete(): Object {
  return {
    type: types.MARK_SIGNUP_AS_COMPLETE,
  };
}

export function markSignupAsIncomplete(): Object {
  return {
    type: types.MARK_SIGNUP_AS_INCOMPLETE,
  };
}
